// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"1273091992c76771839b","655":"1a4fa70163e9235d7305"}[chunkId] + ".js";
};